// extracted by mini-css-extract-plugin
var _1 = "bT6uYmci";
var _2 = "Sdkc1xTC";
export { _1 as "gameField", _2 as "main" }
